<template>
  <div class="mySciencePopularization">
    <ul class="mySciencePopularization_left my_card">
      <li @click="handleTabs(item.id)" v-for="item in tabList" :key="item.id"
          :class="{'is_folder': item.id === activeTab}">
        <div class="folder_name_box">
          <i :class="item.icon"></i>
          <span>{{item.label}}</span>
        </div>
      </li>
    </ul>
    <div class="mySciencePopularization_rigth">
      <template v-for="item in tabList">
        <component :key="item.id" v-if="activeTab == item.id" :detailsId="detailsId" :is="item.value" />
      </template>
    </div>
  </div>
</template>
<script>
import myMaterial from './myMaterial.vue'
import videoTrainingManage from './videoTrainingManage.vue'
import myWork from './myWork.vue'
export default {
  components: {
    myMaterial,
    videoTrainingManage,
    myWork
  },
  data () {
    return {
      tabList: [],
      activeTab: 0,
      detailsId: null
    }
  },
  methods: {
    handleTabs (id) {
      this.activeTab = id
      sessionStorage.setItem('videoObj', JSON.stringify({
        tabActiveName: '14'
      }))
    },
    // 获取我的素材和视频训练管理入口
    async getEntrance () {
      const entrance = Number(window.sessionStorage.getItem('entrance'))
      if (entrance === -1) {
        this.$router.push('/')
      } else {
        this.detailsId = entrance
        this.tabList = [{
          icon: 'el-icon-receiving',
          label: '我的素材',
          value: 'myMaterial',
          id: 0
        }, {
          icon: 'el-icon-video-camera',
          label: '视频训练管理',
          value: 'videoTrainingManage',
          id: 1
        }, {
          icon: 'el-icon-folder-opened',
          label: '我的科普作品',
          value: 'myWork',
          id: 2
        }]
      }
    }
  },
  created () {
    this.activeTab = JSON.parse(window.sessionStorage.getItem('videoObj'))?.tabActive || 0
  },
  mounted () {
    this.getEntrance()
  }
}
</script>
<style lang="less" scoped>
.mySciencePopularization {
  display: flex;
  position: relative;
  width: 100%;
  min-height: 800px;
  .mySciencePopularization_left {
    position: sticky;
    top: 132px;
    width: 200px;
    min-height: 380px;
    max-height: 600px;
    background-color: #fff;
    padding: 0 0 20px;
    overflow-y: auto;
    li {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 50px;
      padding-left: 20px;
      cursor: pointer;
      overflow: hidden;
      &::after {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0 auto;
        content: '';
        width: 160px;
        border-bottom: 1px solid #e8e8e8;
      }
      &:hover {
        background-color: #f1f3f9;
      }
      .folder_name_box {
        display: flex;
        align-items: center;
        font-size: 14px;
        gap: 8px;
        i{
          font-size: 16px;
        }
      }
    }
    .is_folder {
      background-color: #d7dce9 !important;
    }
  }
  .mySciencePopularization_rigth {
    width: 1000px;
    min-height: 100%;
    padding-left: 20px;
  }
}
</style>
